var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "nav-tabs-wrapper bb-0" },
    [
      _c("scrollable-container", [
        _c(
          "ul",
          { staticClass: "nav nav-tabs scroll-container" },
          _vm._l(_vm.tabs, function (tab) {
            return _c(
              "li",
              {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip",
                    value: {
                      disabled: !tab.disabled,
                      placement: "top",
                      title: tab.disabled,
                      boundary: "viewport",
                    },
                    expression:
                      "{\n          disabled: !tab.disabled,\n          placement: 'top',\n          title: tab.disabled,\n          boundary: 'viewport'\n        }",
                  },
                ],
                key: tab.key,
                staticClass: "nav-item",
                class: { "navbar-active": _vm.currentTab === tab.key },
                attrs: { id: tab.key },
                on: {
                  click: function ($event) {
                    return _vm.handleTabChange(tab)
                  },
                },
              },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "nav-link grey-text text-darken-3 clickable",
                    class: { disabled: tab.disabled },
                    attrs: { to: _vm.settingsLink(tab) },
                  },
                  [_vm._v("\n          " + _vm._s(tab.label) + "\n        ")]
                ),
              ],
              1
            )
          }),
          0
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }